

/**
 * Get a display date of a specific point in time based on the current time.
 * 
 * @param date 
 * @returns 
 */
export function getTimeAgo(date: Date): string {
    const now = new Date();
    const diffInSeconds = Math.floor((now.valueOf() - date.valueOf()) / 1000);

    if (diffInSeconds < 1) {
        return "now";
    }

    if (diffInSeconds < 60) {
        return `${diffInSeconds} seconds ago`;
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
        return `${diffInMinutes} minutes ago`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
        return `${diffInHours} hours ago`;
    }

    // If more than 24 hours ago, return the full date and time
    return date.toLocaleString();
}